module.exports = __webpack_public_path__ + "img/riki.6028e4d8.png";